
import Vue from 'vue'
import { settings } from '@/plugins/settings'

export default Vue.extend({
  name: 'StandalonePreview',
  props: {
    lockerId: {
      type: Number,
      default: 0
    },
    deviceId: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      width: 1080,
      height: 1920,
      dynamicScale: 1,
      loading: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateScale()
      window.addEventListener('resize', this.updateScale)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScale)
  },
  computed: {
    containerStyle(): Record<string, string> {
      return {
        width: this.width * this.dynamicScale + 'px',
        height: this.height * this.dynamicScale + 'px',
        overflow: 'hidden',
        position: 'relative',
      }
    },
    iframeStyle(): Record<string, string> {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        transform: `scale(${this.dynamicScale})`,
        transformOrigin: 'top left',
      }
    }
  },
  methods: {
    getPreviewUrl(): string {
      const url = new URL(settings.standaloneUrl);
      url.searchParams.set('notrack', '1');
      url.searchParams.set('uuid', this.deviceId);
      return url.toString();
    },
    updateScale(): void {
      if (typeof window === 'undefined') {
        return
      }

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || this.height
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || this.width

      const wrapper = this.$refs.previewWrapper as HTMLElement | undefined
      let availableHeight = viewportHeight
      let availableWidth = viewportWidth

      if (wrapper) {
        const styles = window.getComputedStyle(wrapper)
        const paddingTop = parseFloat(styles.getPropertyValue('padding-top')) || 0
        const paddingBottom = parseFloat(styles.getPropertyValue('padding-bottom')) || 0
        const paddingLeft = parseFloat(styles.getPropertyValue('padding-left')) || 0
        const paddingRight = parseFloat(styles.getPropertyValue('padding-right')) || 0

        availableHeight -= paddingTop + paddingBottom
        availableWidth -= paddingLeft + paddingRight
      }

      const heightScale = (availableHeight / this.height) * 0.9
      const widthScale = (availableWidth / this.width) * 0.9
      const scale = Math.min(heightScale, widthScale, 1)

      if (!Number.isFinite(scale) || scale <= 0) {
        this.dynamicScale = 0
        return
      }

      this.dynamicScale = scale
    }
  }
})
